import type { EntityAdminRecord } from '@src/components/EntityAdmin/types';
import type { DrawerContentRenderProps } from './registry';
import { getDrawerContentRenderRule } from './registry';

export type DrawerOptionContentProps<TDrawerRecord extends EntityAdminRecord> = DrawerContentRenderProps<TDrawerRecord>;

export function DrawerOptionContent<TDrawerRecord extends EntityAdminRecord>(
  props: DrawerOptionContentProps<TDrawerRecord>
): React.ReactNode {
  const renderRule = getDrawerContentRenderRule<TDrawerRecord>(props.drawerOption.type);
  return renderRule?.renderer(props);
}
